import {
    Alert,
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container, GoBack, Input,
    Row,
    TextArea
} from "design-react-kit";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { properties } from "../../../config/properties";
const styles = {

    card: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle: {
        padding: '2rem',
        borderRadius: 'none',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px #fefefe',
        transition: 'transform 0.2s ease-in-out',
    },
    fieldLabel: {
        fontWeight: '500',
        color: '#6c757d',
        marginBottom: '0.25rem',
        fontSize: '0.9rem',
    },
    fieldValue: {
        marginBottom: '1rem',
        fontWeight: '600',
        fontSize: '1rem',
        color: '#212529',
    },
    formTitle: {
        marginBottom: '1.5rem',
        color: '#333',

        paddingBottom: '0.5rem'
    },
};
const InserimentoDestinatarioMail = ({user}) => {

    const [indirizzo, setIndirizzo] = useState('');
    const [descrizione, setDescrizione] = useState('');
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();


    const closeAlert = () => setOpen(false);

    const handleConferma = async (e) => {
        e.preventDefault(); // blocca reload del form
        setError(null);
        setOpen(false);

        try {
            const response = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/add/destinatarioMail",
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ indirizzo, descrizione, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente })
                }
            );

            if(response.status === 401){

                const datasResponse = await response.json();

                setError('Errore di comunicazione con il server.');
                setOpen(true);
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            if (!response.ok) {
                setError("Errore nel server");
                setOpen(true);
                return;
            }

            const result = await response.json();

            if (result.esito === "OK") {
                navigate('/private/elencoDestinatariMail', { state: { esito: result } });
            } else {
                setError(result.messaggio);
                setOpen(true);
            }

        } catch (err) {
            setError("Errore nel server");
            setOpen(true);
        }
    };

    return (
        <div className={"bg-white py-lg-5"}>
            <Container  className={"mt-lg-5"}>

                <Row className="justify-content-center">
                    <Col md={8} lg={7}>
                        <div style={styles.card}>
                            <h2 style={styles.formTitle}>
                                Inserimento nuovo destinatario
                            </h2>

                            {error && open && (
                                <Alert color="danger" isOpen={open} toggle={closeAlert} className="mb-4">
                                    <strong>Attenzione:</strong> {error}
                                </Alert>
                            )}


                            <form onSubmit={handleConferma}>
                                <Row>
                                    <Input
                                        id="indirizzo"
                                        label="Inserisci Indirizzo *"
                                        type={"email"}
                                        style={{color:'#1a1a1a', fontWeight:'700'}}
                                        value={indirizzo}
                                        onChange={(e) => setIndirizzo(e.target.value)}
                                        required={true}
                                    />
                                </Row>

                                <Row>
                                    <Input
                                        id="descrizione"
                                        label="Inserisci Descrizione"
                                        value={descrizione}
                                        style={{color:'#1a1a1a', fontWeight:'700'}}
                                        onChange={(e) => setDescrizione(e.target.value)}
                                    />
                                </Row>

                                <Row className="mt-3 d-flex justify-content-end">
                                    <Col sm="auto">
                                        <Button
                                            className="btn btn-outline-secondary"
                                            outline
                                            type="button"
                                            onClick={() => navigate('/private/elencoDestinatariMail')}
                                        >
                                            Annulla
                                        </Button>
                                    </Col>
                                    <Col sm="auto">
                                        <Button
                                            className="btn btn-outline-primary"
                                            type="submit"
                                        >
                                            Conferma
                                        </Button>
                                    </Col>
                                </Row>
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default InserimentoDestinatarioMail;
